import { render, staticRenderFns } from "./detailBallskin.vue?vue&type=template&id=6c8ca049&scoped=true"
import script from "./detailBallskin.vue?vue&type=script&lang=js"
export * from "./detailBallskin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8ca049",
  null
  
)

export default component.exports